/* eslint-disable react-hooks/rules-of-hooks */
import type { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';

import { Input } from '@/components/ui/input';
import type { IOneItemInPrepareForRequest } from '@/pages/PurchasesContainer/PurchasesRequests/api/Request.interface';

// const handleUpdateQtyOrDiscountToItem = (
//   cell: MRT_Cell<IOneItemInPrepareForRequest>,
//   value: string,
// ) => {
//   const allItems = [...prepareItems];
//   const itemSelected = allItems.findIndex(
//     (i) =>
//       i.itemBodyID?.toString() === cell.row?.original?.itemBodyID?.toString(),
//   );
//   if (cell?.column?.id === 'Qty' && Number(value) < 0) return;
//   if (
//     cell?.column?.id === 'DiscountEdit' &&
//     (Number(value) < 0 || Number(value) >= 100)
//   )
//     return;
//   if (cell?.column?.id === 'Qty') {
//     allItems[itemSelected].Qty = Number(value);
//     allItems[itemSelected].TotalAfterDiscount =
//       (allItems[itemSelected]?.healthyItemPrice || 0) *
//       Number(value) *
//       ((100 - allItems[itemSelected].DiscountEdit) / 100);
//   }

//   if (cell?.column?.id === 'DiscountEdit') {
//     allItems[itemSelected].DiscountEdit = +value;
//     allItems[itemSelected].TotalAfterDiscount =
//       (allItems[itemSelected]?.healthyItemPrice || 0) *
//       allItems[itemSelected].Qty *
//       ((100 - +value) / 100);
//   }

//   setPrepareItems(allItems);
//   handleLoadingStage(false, 'update');
// };

const DefualtColumn: Partial<ColumnDef<IOneItemInPrepareForRequest>> = {
  cell: ({ getValue, row: { index, original }, column: { id }, table }) => {
    const initialValue = getValue();
    const isDisabled = !(
      original?.HealthyItemID &&
      Math.abs((original?.Price || 0) - (original?.healthyItemPrice || 0)) <=
        0.5
    );

    // We keep and update the cell's state normally.
    // Our state is a number, but when it's 0 we’ll show an empty string.
    const [value, setValue] = useState<number>(Number(initialValue));
    const [totalValue, setTotalValue] = useState<number>(
      Number(original?.TotalAfterDiscount),
    );

    // When the input is blurred, call our table meta's updateData function.
    const onBlur = () => {
      table.options.meta?.updateData(index, id, value > 0 ? value : 0);
      table.options.meta?.updateData(index, 'TotalAfterDiscount', totalValue);
    };

    // If the external initialValue changes, sync it with our state.
    useEffect(() => {
      setValue(Number(initialValue));
    }, [initialValue]);

    // onChange handler:
    // - If the field is cleared, set the state to 0.
    // - If the new number is > 0, update the state.
    // - Otherwise (i.e. 0 or a negative number), set state to 0.
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputVal = e.target.value;
      if (inputVal === '') {
        setValue(0);
      } else {
        if (id === 'Qty' && Number(inputVal) < 0) return;
        if (
          id === 'DiscountEdit' &&
          (Number(inputVal) < 0 || Number(inputVal) >= 100)
        )
          return;
        const newValue = Number(inputVal);
        if (id === 'Qty') {
          setValue(newValue);
          setTotalValue(
            (original?.healthyItemPrice || 0) *
              newValue *
              ((100 - original?.DiscountEdit) / 100),
          );
        } else if (id === 'DiscountEdit') {
          setValue(newValue);
          setTotalValue(
            (original?.healthyItemPrice || 0) *
              original?.Qty *
              ((100 - newValue) / 100),
          );
        }
      }
    };

    return (
      <Input
        disabled={isDisabled}
        className={`m-1 flex min-w-32 max-w-44 border-2 text-center text-3xl disabled:bg-red-800 ${
          value > 0 ? 'bg-indigo-800 text-white' : ''
        }`}
        type="number"
        // Display an empty string when the value is 0.
        value={value > 0 ? value : ''}
        onChange={handleChange}
        onBlur={onBlur}
      />
    );
  },
};

export default DefualtColumn;
